const content = [require("./4/index").default];

export default content;
